import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const ScrollTop = () => {
  const location = useLocation()

  useEffect(() => {
    // Links to a spot on the page (like #comment-12) scroll there instead
    if (!location.hash) {
      window.scrollTo(-100, -100)
    }
  }, [location])

  return null
}

export default ScrollTop
